/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KwhStatisticResponse } from '../../models/kwh-statistic-response';

export interface ApiChargingSessionsStatisticCompanyCodeGet$Json$Params {
  companyCode: string;
}

export function apiChargingSessionsStatisticCompanyCodeGet$Json(http: HttpClient, rootUrl: string, params: ApiChargingSessionsStatisticCompanyCodeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<KwhStatisticResponse>> {
  const rb = new RequestBuilder(rootUrl, apiChargingSessionsStatisticCompanyCodeGet$Json.PATH, 'get');
  if (params) {
    rb.path('companyCode', params.companyCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KwhStatisticResponse>;
    })
  );
}

apiChargingSessionsStatisticCompanyCodeGet$Json.PATH = '/api/ChargingSessions/statistic/{companyCode}';
